import MaterialIcon from '@components/common/MaterialIcon';
import type { KnowledgeArticleDTO } from '@conversed/rest/src/contracts/article-architect/article-architect.dto';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { ArticleBlockquote } from './ArticleBlockquote';
import { ArticleKeywordsSection } from './ArticleKeywordsSection';
import { parseArticleMarkdown } from './article-architect.utils';

interface ArticleCardBodyProps {
  article: KnowledgeArticleDTO;
  blockquoteText?: string | null;
}

export const ArticleCardBody: React.FC<ArticleCardBodyProps> = ({
  article,
  blockquoteText,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <ArticleBlockquote text={blockquoteText} />
      {/* Section divider above the body — icon + label + horizontal rule */}
      <div className='flex items-center gap-2 mb-2'>
        <MaterialIcon
          type='outlined'
          icon='article'
          classes={['text-gray-400', 'text-sm']}
        />
        <span className='text-tiny font-medium text-gray-400 uppercase tracking-wide whitespace-nowrap'>
          {t('article-architect.portal-preview.modal.article-section')}
        </span>
        <div className='flex-1 h-px bg-gray-200' />
      </div>
      <div className='formatted-html-content formatted-html-content--compact text-xs font-normal text-gray-700 break-words'>
        {parseArticleMarkdown(article.body)}
      </div>
      <ArticleKeywordsSection keywords={article.keywords} />
    </>
  );
};
